import React from 'react';
import { uploadEndpointDatasetAttachments } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import { downLoadableAttachmentIcon } from '../helper';
import AttachmentTypeFlag from './AttachmentTypeFlag';
import DatasetAttachmentCardItemExtra from './DatasetAttachmentCardItemExtra';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import FolderToolsMenu from './FolderToolsMenu';

const DatasetFolderCardItem = ({
  attachment,
  category,
  code,
  upward,
}) => {
  const {
    canDownload, canUpdate, isDownloading, isLoading,
  } = Selectors.useDatasetAttachmentCardItem({ category, code, attachment });
  const onFolderClick = Events.useAttachmentFolderPush(category, { code });

  const {
    iconName, iconTitle, color, exceedsDownloadSize, warning,
  } = downLoadableAttachmentIcon(attachment, isDownloading);
  const isLink = canDownload && !isDownloading && !exceedsDownloadSize;
  const {
    id, name, metadata: { description, transferable, viewing },
  } = attachment;

  return (
    <CardItem className="aridhia-attachment-card-item" warning={canUpdate && warning}>
      <NameDescriptionCard
        description={description}
        href={isLink ? uploadEndpointDatasetAttachments(code, id) : undefined}
        icon={iconName}
        iconColour={color}
        iconMessage={iconTitle}
        loading={isLoading}
        markdown
        name={name}
        onClick={() => onFolderClick({ folder: { name: attachment.name, id: attachment.id } })}
        renderSystemFlag={() => <AttachmentTypeFlag attachment={attachment} />}
        system
        withDescriptionShowMore
      >
        <FolderToolsMenu
          allowManage
          folder={attachment}
          category={category}
          code={code}
          upward={upward}
        />
      </NameDescriptionCard>
      {canUpdate && (<DatasetAttachmentCardItemExtra transferable={transferable} viewing={viewing} />)}
    </CardItem>
  );
};

export default DatasetFolderCardItem;
